import React from 'react'
// import { Loader } from 'rsuite'
import { DescriptionTitle, FlexH, FlexV, StepsContainer, ButtonsDiv, BackNextButton, CompletedText, onCompletedStyles } from './EventStyledComponents'
import { VideoFrame, AddToEventButton as StartActivityButton, PhotoFrame, AddToEventButton as MarkAsCompletedButton } from '../Activity/ActivityStyledComponents'
import BriefDescriptionList from './BriefDescriptionList'
import FullDescription from './FullDescription'
import { ArrowLeft, EventIsCompletedIcon, EventIsAlmostCompleted } from '../Icons'

import { Link } from 'react-router-dom'

const getVideoId = activity => {
  const url = activity?.video.embed_url || null
  if (url) {
    let id = url?.split('v=')[1]
    const ampersandPosition = id.indexOf('&')
    ampersandPosition !== -1 ?? (id = id.substring(0, ampersandPosition))
    return id
  } else return null
}

const Overview = (props) => {
  const {
    isEventFinished, setEventFinished,
    setOverview, setCurrentStep, currentActivity, setCurrentActivity,
    currentPhase, setCurrentPhase, phasesLength
  } = props
  const { event } = props
  const phase = event?.phases[currentPhase]
  const activity = phase?.data[currentActivity]
  const activitiesLength = phase?.data.length - 1
  const stepsLength = activity?.steps.length - 1
  const title = activity?.title[0].text
  const videoId = getVideoId(activity)
  const image = activity?.cover_image.thumbnail.url || null

  const isEventDone = event?.phases.every(phase => phase.isCompleted)

  const onActivityChange = activityIndex => {
    if (activityIndex < 0) {
      onPhaseChange(currentPhase - 1)
    } else {
      const stepPosition = phase?.data[activityIndex]?.steps?.length - 1 // to get stepsLength of the previous activity
      setCurrentActivity(activityIndex)
      setCurrentStep(stepPosition)
      setOverview(false)
    }
  }
  const onPhaseChange = phaseIndex => {
    if (phaseIndex < 0) {
      setOverview(true)
    } else if (phaseIndex > phasesLength) {
      setCurrentStep(stepsLength)
      setCurrentActivity(activitiesLength)
      setCurrentPhase(phasesLength)
      setOverview(false)
      setEventFinished(true)
    } else {
      const activitiesPosition = event?.phases[phaseIndex]?.data?.length - 1
      const stepPosition = event?.phases[phaseIndex]?.data[activitiesPosition]?.steps?.length - 1 // to get stepsLength of the previous activity
      setCurrentActivity(activitiesPosition)
      setCurrentStep(stepPosition)
      setCurrentPhase(phaseIndex)
      setOverview(false)
    }
  }
  const onBack = () => { onActivityChange(currentActivity - 1) }

  const onCompleted = () => {
    if (currentPhase < event.phases.length - 1) {
      phase.isCompleted = true
      setCurrentPhase(currentPhase + 1)
    } else {
      phase.isCompleted = true
      setEventFinished(true)
      setOverview(true)
    }
  }

  const returnToUncompletedActivity = () => {
    for (let i = 0; i < event.phases.length; i++) {
      if (!event.phases[i].isCompleted) {
        if (event.phases[i].data[0]) {
          for (let j = 0; j < event.phases[i].data.length; j++) {
            if (!event.phases[i].data[j].isCompleted) {
              setCurrentPhase(i)
              setCurrentActivity(j)
              setCurrentStep(0)
              setEventFinished(false)
              setOverview(true)
              break
            }
          }
          break
        } else { // true if there's uncompleted phase without any activity
          setCurrentPhase(i)
          setCurrentStep(0)
          setEventFinished(false)
          setOverview(true)
          break
        }
      }
    }
  }
  console.log(isEventFinished)
  return (
    <>
      {!isEventFinished && !activity
        ? <EmptyPhase
          setCurrentActivity={setCurrentActivity}
          setCurrentPhase={setCurrentPhase}
          setCurrentStep={setCurrentStep}
          currentPhase={currentPhase}
          onCompleted={onCompleted}
          setOverview={setOverview}
        />
        : !isEventFinished &&
          <PhaseOverview
            activity={activity}
            currentPhase={currentPhase}
            currentActivity={currentActivity}
            setOverview={setOverview}
            onBack={onBack}
            videoId={videoId}
            title={title}
            image={image}
          />}
      {isEventFinished &&
        <>
          {isEventDone
            ? <EventDone
              setEventFinished={setEventFinished}
              setOverview={setOverview}
            />
            : <IncompleteActivity
              setEventFinished={setEventFinished}
              setOverview={setOverview}
              returnToUncompletedActivity={returnToUncompletedActivity}
            />}
        </>}
    </>
  )
}

const PhaseOverview = ({ activity, setOverview, currentActivity, currentPhase, onBack, videoId, image, title }) => {
  return (
    <>
      <DescriptionTitle style={{ padding: '0 20px' }}> {activity.topic} </DescriptionTitle>
      <StepsContainer>
        <FlexH>
          <FlexV>
            {videoId
              ? <VideoFrame src={`https://www.youtube.com/embed/${videoId}?feature=oembed}`} />
              : image && <PhotoFrame src={image} />}
            <BriefDescriptionList activity={activity} />
          </FlexV>

          <FlexV>
            <DescriptionTitle style={{ padding: '0 20px' }}> {title} </DescriptionTitle>
            <FullDescription
              fullDescription={activity.description}
              tools={activity.requisites} // tools
              goals={activity.goals}
              preparation={activity.preparation}
            />
          </FlexV>
        </FlexH>
      </StepsContainer>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ButtonsDiv>
          <BackNextButton onClick={onBack} disabled={!currentPhase && !currentActivity}> <ArrowLeft />&nbsp; back </BackNextButton>
          <StartActivityButton onClick={() => { setOverview(false) }}> Start activity </StartActivityButton>
        </ButtonsDiv>
      </div>
    </>
  )
}

const EmptyPhase = ({ setCurrentPhase, setCurrentActivity, setCurrentStep, setOverview, onCompleted, currentPhase }) => {
  return (
    <>
      <div style={onCompletedStyles.flexColumn}>
        <div style={onCompletedStyles.image}> <EventIsAlmostCompleted /> </div>
        <span style={onCompletedStyles.span}>
          This Phase has no activities. Please mark completed to move to the next phase
        </span>
      </div>
      <FlexH style={onCompletedStyles.flexRowCenter}>
        <ButtonsDiv>
          <BackNextButton onClick={() => { setCurrentPhase(currentPhase - 1); setCurrentActivity(0); setCurrentStep(0); setOverview(false) }}> <ArrowLeft />&nbsp; back </BackNextButton>
          <MarkAsCompletedButton onClick={onCompleted}>Mark as completed </MarkAsCompletedButton>
        </ButtonsDiv>
      </FlexH>
    </>
  )
}

const EventDone = ({ setEventFinished, setOverview }) => {
  return (
    <>
      <div style={onCompletedStyles.flexColumn}>
        <div style={onCompletedStyles.image}> <EventIsCompletedIcon /> </div>
        <span style={onCompletedStyles.title}>That's all, well done!</span>
        <span style={onCompletedStyles.span}>
          The event is completed. You can go back to your other events or review this one by phases and activities.
        </span>
        <Link to='/events'>
          <StartActivityButton style={onCompletedStyles.button}> To my events </StartActivityButton>
        </Link>
      </div>
      <FlexH style={onCompletedStyles.flexRow}>
        <CompletedText>&#10003; COMPLETED</CompletedText>
        <ButtonsDiv>
          <BackNextButton onClick={() => { setEventFinished(false); setOverview(false) }}> <ArrowLeft />&nbsp; back </BackNextButton>
        </ButtonsDiv>
      </FlexH>
    </>
  )
}

const IncompleteActivity = ({ setEventFinished, setOverview, returnToUncompletedActivity }) => {
  return (
    <>
      <div style={onCompletedStyles.flexColumn}>
        <div style={onCompletedStyles.image}> <EventIsAlmostCompleted /> </div>
        <span style={onCompletedStyles.title}>You almost missed it...</span>
        <span style={onCompletedStyles.span}>
          There is one or few activities you left uncompleted. Get back to them or skip and go to your other events.
        </span>
        <FlexH>
          <Link to='/events'>
            <StartActivityButton reverse style={onCompletedStyles.button}> To my events </StartActivityButton>
          </Link>
          <StartActivityButton
            style={onCompletedStyles.button.toUncompleted}
            onClick={returnToUncompletedActivity}
          >
            To uncompleted activity
          </StartActivityButton>
        </FlexH>
      </div>
      <FlexH style={onCompletedStyles.flexRow}>
        <CompletedText>&#10003; COMPLETED</CompletedText>
        <ButtonsDiv>
          <BackNextButton onClick={() => { setEventFinished(false); setOverview(false) }}> <ArrowLeft />&nbsp; back </BackNextButton>
        </ButtonsDiv>
      </FlexH>
    </>
  )
}

export default Overview
